// extracted by mini-css-extract-plugin
export default {"wrapper":"ConfirmDashboardDeletionModal_wrapper__FJxqO","trackersWrapper":"ConfirmDashboardDeletionModal_trackersWrapper__tDzYK"};